// extracted by mini-css-extract-plugin
module.exports = {"NavLink":"NavLink_NavLink__3nALe","NavLinkActive":"NavLink_NavLinkActive__17PV4","back":"NavLink_back__2adrK","colorshift":"NavLink_colorshift__1H7yY"};